import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../services/inventory_appCommonService";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../Components/formElements/SearchField";
import {
  addStock,
  getStockList,
} from "../../../redux/feature/inventory_app/inventorySlice";
import QrCodePrint from "./QrCodePrint";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import toast from "react-hot-toast";
import { getModuleStats } from "../../../redux/feature/warehouse_app/warehouseSlice";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import WarehouseConstants from "../../../common/WarehouseConstants";

const StockList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Stock");
  localStorage.setItem("submenu", "stock");
  let stockData = useSelector((state) => state?.inventory?.stock); // User Details from Store
  let stockDataTable = useSelector(
    (state) => state?.inventory?.stock?.pagination,
  ); // User Details from Store

  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /*setSendDataModal*/] = useState("");
  const [modelTitle /*setModelTitle*/] = useState("");

  //cancle and delete
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [getSelectedRows, setSelectedRows] = useState([]);
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const statsPayload = {
    dashboard: "warehouse",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };
  const refreshWarehousePage = () => {
    dispatch(getStockList(DEFAULT_LIST_PARAMS));
    dispatch(getModuleStats(statsPayload));
  };
  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : getSelectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.statusHeader !== "Cancelled" && item?.statusHeader !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.stockNr)));
  };

  useEffect(() => {
    if (!showStats) {
      setFilteredData(stockData.data);
    }
  }, [showStats, stockData]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  const createStock = () => {
    navigate(WarehouseConstants.WH_STOCK_CREATION);
  };
  const detailedPage = (stockNr) => {
    dispatch(addStock(stockNr));
    navigate(WarehouseConstants.WH_STOCK_DETAILS);
  };
  //on page load
  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const loadInitialStockData = async () => {
    setData(stockData?.data);
  };
  const [getModalQr, setModalQr] = useState(false);
  const [qrData, setQrData] = useState(null);

  const qrCodeGenerate = (data) => {
    setModalQr(true);
    setQrData(data);
  };

  const hideQrModal = () => {
    setModalQr(false);
  };
  const DEFAULT_LIST_PARAMS = {
    queryName: "GET_STOCK_LIST",
    module: "",
    page: 1,
    per_page: 10,
  };

  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : getSelectedRows;

      const payload = {
        documentNumber: rows.map((item) => item.stockNr),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };

      const res = await ItemService.cancelOrDeleteStock(payload);

      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });

        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };

  const columns = [
    // {
    //   name: "Document Nr",
    //   id: "stockNr",
    //   cell: (row) => (
    //     <button className="btnInfo" onClick={() => detailedPage(row.stockNr)}>
    //       {row.stockNr}{" "}
    //     </button>
    //   ),
    //   width: "150px",
    // },
    {
      name: "Document Nr",
      id: "documentNumber",
      cell: (row) => {
        const docNo = row.stockNr || row.draftNr;

        return (
          <button className="btnInfo" onClick={() => detailedPage(docNo, row)}>
            {docNo}
          </button>
        );
      },
      width: "150px",
    },
    {
      name: "Stock Code",
      selector: (row) => row.stockCode,
      id: "stockCode",
      dropdDown: "true",
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.stockCode}</span>
      ),
      width: "130px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.headerStatus} />
        </>
      ),
      selector: (row) => row.headerStatus || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Product",
      selector: (row) => row.productName,
      id: "productName",
      dropDown: "true",
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.productName}</span>
      ),
      width: "130px",
    },
    {
      name: "Generate Qr",
      cell: (row) => (
        <>
          <button className="btnInfo" onClick={() => qrCodeGenerate(row)}>
            Qr
          </button>
        </>
      ),
      width: "120px",
    },
    {
      name: "Material",
      selector: (row) => row.materialName,
      id: "materialName",
      dropDown: "true",
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.materialName}</span>,
      width: "120px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      id: "quantity",
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.quantity}</span>,
      width: "90px",
    },
    {
      name: "Stock Description",
      selector: (row) => row.stockDesc,
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.stockDesc}</span>,
      width: "160px",
    },
    {
      name: "Stock Group",
      selector: (row) => row.stockGroup,
      id: "stockGroup",
      dropDown: "true",
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.stockGroup}</span>,
      width: "130px",
    },
    {
      name: "UOM",
      selector: (row) => row.uOM,
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.uOM}</span>,
      width: "100px",
    },
    {
      name: "Batch Number",
      selector: (row) => row.batchNumber,
      id: "batchNumber",
      dropDown: "true",
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 ">{row.batchNumber}</span>,
      width: "160px",
    },
    {
      name: "Supplier",
      selector: (row) => row.supplierName,
      id: "supplierName",
      dropDown: "true",
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1">{row.supplierName}</span>,
      width: "150px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocation,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1">{row.storageLocation}</span>
      ),
      width: "160px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;

        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";

        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(row.stockNr))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => detailedPage(row.stockNr),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "Cancel"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];

  const handlePageChange = (page) => {
    let obj = {
      ueryName: "Get_Stock_Details",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getStockList(obj));
    setData(stockData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getStockList(obj));
    setData(stockData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getStockList(obj));
  };

  const handleSuccessData = async (data) => {};
  //on page load
  useEffect(() => {
    let obj = {
      queryName: "GET_STOCK_LIST",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getStockList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadInitialStockData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockData]);

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "GET_STOCK_LIST",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getStockList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Stock</h2>
                <p className="subText">Lists of Stock and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                fetchFunction={ItemService.getStockList} // Replace with your actual fetch function
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="stocks"
                  keyName="headerStatus"
                  paginatedList={stockData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Stock List</span>
                      <span className="subHeaderTitle">
                        View of Stock and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/* {config?.createManualPOBtn && ( */}
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => createStock()}
                        >
                          <i className="bi bi-clipboard-check"></i> Create Stock
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={stockData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={stockDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <QrCodePrint
        show={getModalQr}
        onHide={() => hideQrModal()}
        qrInfo={qrData}
        onsuccessdata={handleSuccessData}
      />
      <CancelModal
        title={
          actionType === "Delete" ? "Delete the Stock" : "Cancel the Stock"
        }
        type="Stock"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="stockNr"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
    </main>
  );
};
export default StockList;
